// Stock CARO background, shown on the home photo frame AND the screensaver when
// the resident has no photos of their own. Single source of truth for both.
export const DEFAULT_BACKGROUND_URL = 'https://caro.care/images/default.png';
